// codes of languages which are written from right-to-left
// https://meta.wikimedia.org/wiki/Template:List_of_language_names_ordered_by_code
const RtlLanguageList: ReadonlySet<string> = new Set([
    'ar', // Arabic
    'arc', // Aramaic
    'dv', // Divehi
    'fa', // Farsi / Persian (ISO 639-1)
    'far', // Farsi / Persian (legacy)
    'ha', // Hausa
    'he', // Hebrew
    'khw', // Khowar
    'ks', // Kashmiri
    'ku', // Kurdish
    'ps', // Pashto
    'sd', // Sindhi
    'ug', // Uighur
    'ur', // Urdu
    'yi', // Yiddish
]);

/** Primary language subtag of a locale or code, lowercased — e.g. `'en-US'` -> `'en'`, `'it'` -> `'it'`. */
function getPrimaryLanguageSubtag(langCode: string): string {
    return langCode.split('-')[0].toLowerCase();
}

function isLanguageRtl(langCode: string) {
    return RtlLanguageList.has(getPrimaryLanguageSubtag(langCode));
}

function shouldRtlLanguageBeUsed(langCode: string | null | undefined) {
    if (!langCode) {
        return false;
    }
    return isLanguageRtl(langCode);
}

export { getPrimaryLanguageSubtag, isLanguageRtl, shouldRtlLanguageBeUsed };
